import React from 'react';
import { isEqual } from 'lodash';

type UseEffectParams = Parameters<typeof React.useEffect>;
type EffectCallback = UseEffectParams[0];
type DependencyList = UseEffectParams[1];

type UseEffectReturn = ReturnType<typeof React.useEffect>;

// function checkDeps(deps: DependencyList) {
//   if (!deps || !deps.length) {
//     throw new Error(
//       'useDeepCompareEffect should not be used with no dependencies. Use React.useEffect instead.'
//     );
//   }
//   if (deps.every(isPrimitive)) {
//     throw new Error(
//       'useDeepCompareEffect should not be used with dependencies that are all primitive values. Use React.useEffect instead.'
//     );
//   }
// }

// function isPrimitive(val: unknown) {
//   return val == null || /^[sbn]/.test(typeof val);
// }

function useDeepCompareMemoize<T>(value: T) {
  const ref = React.useRef<T>(value);
  const signalRef = React.useRef<number>(0);

  if (!isEqual(value, ref.current)) {
    ref.current = value;
    signalRef.current += 1;
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React.useMemo(() => ref.current, [signalRef.current]);
}

export default function useDeepCompareEffect(
  callback: EffectCallback,
  dependencies: DependencyList
): UseEffectReturn {
  // if (process.env.NODE_ENV !== 'production') {
  //   checkDeps(dependencies);
  // }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React.useEffect(callback, useDeepCompareMemoize(dependencies));
}
